module.exports = __webpack_public_path__ + "static/images/containers/Challenges/components/Challenge/images/borders-selection.94c476df.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Challenges/components/Challenge/images/borders-selection.png
// module id = 2834
// module chunks = 11